module.exports = __webpack_public_path__ + "img/tz_niu2.6842eff6.png";